import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { CatalogueData, SourceData } from '../vform.models';

@Component({
  selector: 'vf-vsource',
  templateUrl: './vsource.component.html',
  styleUrls: ['./vsource.component.scss'],
  standalone: false,
})
export class VsourceComponent implements OnInit {
  @Input()
  sourceData: AbstractControl;
  @Input()
  catalogue: CatalogueData;
  @Input()
  enableInternetDataProviders: boolean;
  @Input()
  columns: number;

  directorySites: SourceData[];
  reviewSites: SourceData[];
  searchEngines: SourceData[];
  socialSites: SourceData[];
  internetDataProviders: SourceData[];

  disabledSources: number[];

  ngOnInit() {
    this.directorySites = this.organizeSourceList(this.catalogue.source.sources['Directory Site']);
    this.reviewSites = this.organizeSourceList(this.catalogue.source.sources['Review Site']);
    this.searchEngines = this.organizeSourceList(this.catalogue.source.sources['Search Engine']);
    this.socialSites = this.organizeSourceList(this.catalogue.source.sources['Social Site']);
    this.internetDataProviders = this.organizeSourceList(this.catalogue.source.sources['Internet Data Provider']);

    this.disabledSources = [...this.sourceData.value[1]];
    // Scrub the disabled sources from the "value" of this control for when the form gets submitted.
    this.sourceData.patchValue(this.sourceData.value[0]);
    this.sourceData.valueChanges.subscribe(console.log);
  }

  organizeSourceList(sources: SourceData[]): SourceData[] {
    if (!sources) {
      return [];
    }
    return sources.sort((a, b) => {
      const textA = a.name.toUpperCase();
      const textB = b.name.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  }

  updateValues(checked: boolean, sourceId: number): void {
    const current = [...this.sourceData.value];
    if (checked) {
      // add to sourceData
      current.push(sourceId);
      this.sourceData.patchValue(current);
      return;
    }
    // remove from sourceData
    this.sourceData.patchValue(current.filter((sId) => sId !== sourceId));
  }
}
